import {
  IconBrain,
  IconBuildingFactory2,
  IconDashboard,
  IconFilePlus,
  IconFolder,
  IconTemplate,
} from "@tabler/icons-react";

import { Icon } from "#shared/icons/Icon";
import { ROUTES } from "#shared/routes";
import { Link } from "#shared/view/components/AppShell/NavLink";

export const links: (Link & { children?: Link[] })[] = [
  {
    label: "Demandes en cours",
    href: ROUTES.partner,
    icon: IconFolder,
  },
  {
    label: "Nouvelle demande",
    href: ROUTES.partnerQuoteRequestsNew,
    icon: IconFilePlus,
  },
  { label: "Tableau de bord", href: ROUTES.partnerDashboard, icon: IconDashboard },
  {
    label: "Mes modèles de gamme",
    href: ROUTES.partnerManufacturingRanges,
    icon: IconTemplate,
  },
  {
    label: "Mon entreprise",
    href: ROUTES.partnerSettings,
    icon: IconBuildingFactory2,
    children: [
      {
        label: "Informations entreprise",
        href: ROUTES.partnerSettingsInformations,
      },
      {
        label: "Mon compte",
        href: ROUTES.partnerSettingsAccount,
      },
      {
        label: "Mes clients",
        href: ROUTES.partnerSettingsClients,
      },
      {
        label: "Demandes entrantes",
        href: ROUTES.partnerSettingsIncomingRequests,
      },
      {
        label: "Configuration chiffrage",
        href: ROUTES.partnerSettingsQuoting,
      },
      {
        label: "Parc machine",
        href: ROUTES.partnerSettingsMachines,
      },
    ],
  },
  {
    label: "Intelligence artificielle",
    href: ROUTES.partnerIa,
    icon: IconBrain,
    children: [
      {
        label: "Recherche",
        href: ROUTES.partnerIaSearch,
        icon: () => <Icon name="search" />,
      },
      {
        label: "Prédiction",
        href: ROUTES.partnerIaPrediction,
        icon: () => <Icon name="shapeTriangle" />,
        isBetaFeature: true,
      },

      {
        label: "Jeu de données",
        href: ROUTES.partnerIaDataset,
        icon: () => <Icon name="cube" />,
      },
    ],
  },
];
